const adminInit = "/admin/dashboard";

export const dashboardRoute = {
  auth: "/auth",
  dashboard: adminInit,
  admin: {
    home: `${adminInit}/home`,
    user: `${adminInit}/user`,
    trainer: `${adminInit}/trainer`,
    inventory: `${adminInit}/inventory`,
    subAdmins: `${adminInit}/subadmins`,
    userProfile: {
      link: `${adminInit}/user`,
      params: "userId",
    },
    trainerProfile: {
      link: `${adminInit}/trainer`,
      params: "trainerId",
    },
    qrUser: {
      modalName: "QrSearch",
      link: `${adminInit}/qr`,
      params: "userId",
    },
    notification: `${adminInit}/notification`,
    classes: `${adminInit}/classes`,
    plans: `${adminInit}/plans`,
    hmo: `${adminInit}/hmo`,
    slots: `${adminInit}/slots`,
    announcement: `${adminInit}/announcement`,
    report: `${adminInit}/report`,
    financialReport: `${adminInit}/financialReport`,
  },
};
